export enum SubscriptionType {
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  NO_SUB = 'NO_SUB',
}
